// Lightweight logger.
// In development: log to console so debugging is easy.
// In production: silent — keeps the console clean for users and avoids the
//                noise / minor perf hit of debug logging in production builds.
//
// Use this in non-critical UI refresh handlers where a thrown error would
// otherwise be silently swallowed by a bare `catch {}`. We don't want to
// surface a toast for these — they're usually "user navigated away while
// fetching" — but we still want them visible during development.

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },     // eslint-disable-line no-console
  info:  (...args) => { if (isDev) console.info(...args); },      // eslint-disable-line no-console
  warn:  (...args) => { if (isDev) console.warn(...args); },      // eslint-disable-line no-console
  error: (...args) => { if (isDev) console.error(...args); },     // eslint-disable-line no-console
};

export default logger;
